import initWxShare from "@/utils/initWxShare"
import { getRegionData } from "@/server/interfaces"
import deepClone from "@/utils/deepClone"
// import router from "@/router"

// const TAB_AREA_KEY = "AREA"
// const POPULARITY_KEY = "POPULARITY"
// const LATEST_RELEASE_KEY = "LATEST_RELEASE"
// const RECOMMEND_KEY = "RECOMMEND"
// const WORKS_TYPE_KEY = "WORKSTYPE"

export default {
  namespaced: true,
  state: {
    activityId: "",
    activityDetail: {
      id: "",
      activityName: "",
      backgroundPicUrl: "",
      detail: "",
      shareTitle: "",
      shareDesc: "",
      shareIconUrl: "",
      indexNavigations: [],
      defaultOptions: [],
      activityCategorys: {},
      worksTypes: []
    },
    activityBannerDesc: {
      banner: "",
      desc: ""
    },
    regionData: [],
    areaPickerRegionData: [],
    activityCategorys: [],
    worksTypesList: [],
    shareInfo: {
      title: " ",
      desc: `“南方+”创造更多价值！`,
      link: window.location.href,
      imgUrl: "https://static.nfapp.southcn.com/app/nanfang_logo.png"
    },
    activityInfo: null
  },
  getters: {
    regionData: state => state.regionData,
    areaPickerRegionData: state => state.areaPickerRegionData,
    indexNavigations: state => state.activityDetail.indexNavigations,
    activityCategorys: state => state.activityCategorys,
    defaultOptions: state => state.activityDetail.defaultOptions,
    backgroundPicUrl: state => state.activityDetail.backgroundPicUrl,
    activityId: state => state.activityId,
    activityInfo: state => state.activityInfo,
    activityDetails: state => state.activityDetail.detail,
    activityName: state => state.activityDetail.activityName,
    activityDetailDesc: state => state.activityDetail,
    worksTypes: state => state.worksTypesList,
    allWorksTypes: state => state.activityDetail.worksTypes,
    activityBannerDesc: state => state.activityBannerDesc,
    shareInfo: state => state.shareInfo,
    aliNvcValStatus: state => state.activityDetail.aliNvcValStatus
  },
  mutations: {
    setShareInfo(state, shareInfo) {
      state.shareInfo = Object.assign({}, state.shareInfo, shareInfo)
    },
    setActivityInfo(state, activityInfo) {
      state.activityInfo = Object.assign({}, state.activityInfo, activityInfo)
    },
    setActivityId(state, activityId) {
      state.activityId = activityId
    },
    setActivityDetail(state, activityDetail) {
      activityDetail.detail = activityDetail.detail.replace(/\n/g, "<p style='margin-bottom: 0.46rem;'></p>")
      state.activityDetail = activityDetail
    },
    setRegionData(state, regionData) {
      const resolveRegionData = (key = "childOrg", parentArr = regionData) => {
        if (parentArr && Array.isArray(parentArr) && parentArr.length > 0) {
          parentArr.forEach(item => {
            if (item.children && Array.isArray(item.children) && item.children.length > 0) {
              item[key] = item.children.slice(0)
              resolveRegionData("childOrg", item.children)
            }
          })
        }
      }
      resolveRegionData("childOrg", regionData)
      state.regionData = regionData
    },
    setAreaPickerRegionData(state, regionData) {
      const extraAreaArr = ["其他"]
      const areaPickerRegionData = deepClone(regionData)
      const allArea = {
        name: "全部",
        isAll: true,
        children: [
          {
            name: "全部城市",
            isAll: true,
            children: [
              {
                name: "全部区县",
                isAll: true
              }
            ]
          }
        ]
      }
      areaPickerRegionData.forEach(item => {
        const allPickerChildren = {
          name: "全部城市",
          isAll: true,
          children: [
            {
              name: "全部区县",
              isAll: true
            }
          ]
        }
        const isExtraArea = extraAreaArr.includes(item.name)
        if (!isExtraArea) {
          item.children.forEach(childItem => {
            const allDistrict = {
              name: "全部区县",
              isAll: true
            }
            if (childItem.children && Array.isArray(childItem.children)) {
              childItem.children.unshift(allDistrict)
            }
          })
          item.children.unshift(allPickerChildren)
        }
      })
      areaPickerRegionData.push(allArea)
      const resolveRegionData = (key = "childOrg", parentArr = regionData) => {
        if (parentArr && Array.isArray(parentArr) && parentArr.length > 0) {
          parentArr.forEach(item => {
            if (item.children && Array.isArray(item.children) && item.children.length > 0) {
              item[key] = item.children.slice(0)
              resolveRegionData("childOrg", item.children)
            }
          })
        }
      }
      resolveRegionData("childOrg", areaPickerRegionData)
      state.areaPickerRegionData = areaPickerRegionData
    },
    setActivityCategorys(state, activityCategorys) {
      state.activityCategorys = activityCategorys
        .filter(item => item.display === "YES")
        .map(item => {
          return {
            label: item.name,
            ...item
          }
        })
      state.activityCategorys.unshift({
        label: "全部活动",
        id: "",
        isAll: true
      })
    },
    // @TODO 待完善
    setWorksType(state) {
      if (state.activityDetail.worksTypes) {
        state.worksTypesList = state.activityDetail.worksTypes
          .filter(item => item.display === "YES")
          .map(item => {
            return {
              label: item.typeName,
              ...item
            }
          })
        state.worksTypesList.unshift({
          label: "全部",
          id: "",
          typeId: "",
          isAll: true
        })
      }
    },
    refreshActivityBannerDesc(state, activityItem) {
      const activityBannerDesc = {
        banner: state.activityDetail.backgroundPicUrl,
        desc: state.activityDetail.detail
      }
      if (activityItem && activityItem.activityPicUrl && activityItem.activityDesc) {
        activityBannerDesc.banner = activityItem.activityPicUrl
        activityBannerDesc.desc = activityItem.activityDesc
      }
      state.activityBannerDesc = Object.assign({}, state.activityBannerDesc, activityBannerDesc)
    }
  },
  actions: {
    initWxShare({ rootState }) {
      const isWx = rootState.systemInfo.isWx
      if (!isWx) return
      const shareOptions = { ...rootState.activityInfo.shareInfo }
      initWxShare(shareOptions)
    },
    initNfPluseShare({ rootState }) {
      const isNfPlus = rootState.systemInfo.isNfPlus
      const shareInfo = rootState.activityInfo.shareInfo
      if (!isNfPlus) return
      try {
        if (window.nfplusJsbridge) {
          let version = window.nfplusJsbridge.getInsideVersion()
          window.console.log({ version })
          if (version && version < 660) {
            window.nfplusJsbridge.needUpgrade() //版本低于660，调用更新提示
          } else {
            window.nfplusJsbridge.setShareInfo({
              title: shareInfo.title,
              content: shareInfo.desc,
              icon: shareInfo.imgUrl,
              url: shareInfo.link
            })
            // window.nfplusJsbridge.nfShare({
            //   title: shareInfo.title,
            //   content: shareInfo.desc,
            //   icon: shareInfo.imgUrl,
            //   url: shareInfo.link
            // })
          }
        }
      } catch (error) {
        window.console.error(error)
      }
      // const shareInfo = rootState.activityInfo.shareInfo
      // const nfPlusShareInfo = {
      //   shareTitle: shareInfo.title,
      //   shareIcon: shareInfo.imgUrl,
      //   shareDesc: shareInfo.desc,
      //   shareUrl: shareInfo.link
      // }
      // window.nfplusJsbridge.setShareInfo(nfPlusShareInfo)
    },
    initShareInfo({ dispatch }) {
      dispatch("initWxShare")
      dispatch("initNfPluseShare")
    },
    async getRegionData({ commit }) {
      const regionData = await getRegionData()
      commit("setRegionData", regionData)
      commit("setAreaPickerRegionData", regionData)
    }
  }
}
